var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.891,
    height: 25,
    viewBox: "0 0 12.891 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook-f",
    d: "M3.745 25V13.818H0V9.375h3.745v-3.5C3.745 2.07 6.069 0 9.463 0a31.442 31.442 0 0 1 3.428.176V4.15h-2.354c-1.846 0-2.2.879-2.2 2.163v3.062H12.5l-.571 4.443H8.335V25",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookF);
export default __webpack_public_path__ + "static/media/facebook-f.7875f8a7e558c170bd4d4f39a7168533.svg";
export { ForwardRef as ReactComponent };